import styled from 'styled-components';

export const StyledTagSquare = styled.span`
  .tag-square {
    display: inline-flex;
    align-items: center;
    border: 1px solid ${({ theme }) => theme.colors.getTransparentColor(theme.colors.mainOrange, 0.3)};
    background: ${({ theme }) => theme.colors.getTransparentColor(theme.colors.mainOrange, 0.06)};
    text-transform: uppercase;
    width: fit-content;
    height: 35px;
    padding: 0 14px;
    border-radius: 5px;
    cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
    transition: all ease 0.4s;

    p {
      color: ${({ theme }) => theme.colors.raven};
    }

    &:hover {
      background: ${({ theme }) => theme.colors.getTransparentColor(theme.colors.mainOrange, 0.12)};
      border-color: ${({ theme }) => theme.colors.mainOrange};

      p {
        color: ${({ theme }) => theme.colors.mainOrange};
      }
    }
  }
`;
